import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=a1251c7a&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=a1251c7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1251c7a",
  null
  
)

export default component.exports